<template>
	<div>
		<!-- 面包屑导航 -->
		<div>
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item class="mybread" :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item class="mybread">管理员权限</el-breadcrumb-item>
				<el-breadcrumb-item class="mybread">角色名单</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<!-- tabs的使用-->
		<div class="tabname">
			<el-tabs v-model="activeName2">
				<!-- 党员联系老师名单管理-->
				<el-tab-pane name="dyjslist">
					<span slot="label"><i class="el-icon-date"></i> 党员联系老师名单</span>
					<!-- 第一行搜索框和新增人员按钮 -->
					<el-row type="flex" align="middle" class="myRow">
						<el-col :span="3">用户搜索</el-col>
						<el-col :span="7">
							<el-input placeholder="请输入姓名" v-model="queryInfo.fullName" clearable>
								<el-button slot="append" icon="el-icon-search" @click="mygetlistLXLS()"></el-button>
							</el-input>
						</el-col>
						<el-col :span="1" :offset="1">
							<el-button icon="el-icon-plus" circle @click="addUserDialogVisible = true"
								title="新增用户"></el-button>
						</el-col>
						<el-col :span="1">
							<el-button icon="el-icon-download" circle @click="downloadMoban()" title="下载模板"></el-button>
						</el-col>
						<el-col :span="1">
							<!-- 批量导入 -->
							<el-button icon="el-icon-document-add" circle @click="$refs.excelBtn.click()"
								title="批量导入用户"></el-button>
							<el-upload v-show="false"
								accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
								action :auto-uplonpad="false" :show-file-list="false" :on-change="importData">
								<span ref="excelBtn">导入EXCEL</span>
							</el-upload>
						</el-col>
					</el-row>
					<!-- 新增联系党员对话框-->
					<el-dialog title="新增人员" :visible.sync="addUserDialogVisible" width="30%">
						<el-form :model="addUserForm" :rules="addUserFormRules" ref="addUserFormRef" label-width="85px">
							<el-form-item label="工号/学号" prop="username">
								<el-input v-model="addUserForm.username" style="width: 200px"></el-input>
								<el-button icon="el-icon-search" circle @click="queryLXLS"></el-button>
							</el-form-item>
							<el-form-item label="用户姓名" prop="fullName">
								<el-input v-model="addUserForm.fullName" :disabled="true" style="width:300px"></el-input>
							</el-form-item>
							<el-form-item label="手机号码" prop="mobile">
								<el-input v-model="addUserForm.mobile" :disabled="true" style="width:300px"></el-input>
							</el-form-item>
							<el-form-item label="联系班级" prop="banji">
								<el-input placeholder="请输入班级名称。例如计应20-1" v-model="addUserForm.banji"></el-input>
							</el-form-item>
						</el-form>
						<span slot="footer" class="dialog-footer">
							<el-button @click="addUserDialogVisible = false">取 消</el-button>
							<el-button type="primary" @click="myaddLXLS()">确 定</el-button>
						</span>
					</el-dialog>
					<!--批量导入结果对话框-->
					<el-dialog title="批量导入结果" :visible.sync="importdialogVisible" width="30%">
						<span>党员联系老师信息已经成功导入{{ this.succ_num }}条，失败{{ this.fali_num }}条。</span><br/>
						<span>说明：如果导入信息失败，请检查该用户是否注册或重复导入。</span>
						<span slot="footer" class="dialog-footer">
							<el-button @click="importdialogVisible = false">取 消</el-button>
							<el-button type="primary" @click="importdialogVisible = false">确 定</el-button>
						</span>
					</el-dialog>
					<el-table :data="dylslist" border style="width: 100%" height="calc(100vh - 13rem)" :header-cell-style="{
						background: '#fff1f0', height: '60px', color: '#000000'
					}">
						<el-table-column type="index" width="150px">
						</el-table-column>
						<el-table-column prop="username" label="工号" width="250px">
						</el-table-column>
						<el-table-column prop="fullName" label="姓名" width="250px" >
						</el-table-column>
						<el-table-column prop="banji" label="联系班级" width="250px">
						</el-table-column>
						<el-table-column label="操作"  width="230px">
							<template slot-scope="scope">
								<el-popconfirm @confirm="mydeleteLXLS(scope.row.banji, scope.row.userId)"
									title="确定要删除该党员联系老师吗？">
									<el-button type="danger" slot="reference" size="mini" title="删除教职工"
										icon="el-icon-delete" circle></el-button>
								</el-popconfirm>
							</template>
						</el-table-column>
					</el-table>
				</el-tab-pane>
				<!-- 组织委员名单管理-->
				<el-tab-pane>
					<span slot="label"><i class="el-icon-date"></i> 组织委员名单</span>
					<el-row type="flex" align="middle" class="myRow">
						<el-col :span="3">用户搜索</el-col>
						<el-col :span="7">
							<el-input placeholder="请输入姓名" v-model="queryInfo.zzwyName" clearable>
								<el-button slot="append" icon="el-icon-search" @click="mylistRoles()"></el-button>
							</el-input>
						</el-col>

					</el-row>
					<el-table :data="zzwylist" border style="width: 100%" height="calc(100vh - 13rem)" :header-cell-style="{
						background: '#fff1f0', height: '60px', color: '#000000'
					}">
						<el-table-column type="index" width="150">
						</el-table-column>
						<el-table-column prop="username" label="工号" width="250px">
						</el-table-column>
						<el-table-column prop="fullName" label="姓名" width="250px">
						</el-table-column>
						<el-table-column prop="banji" label="所在班级" width="250px">
						</el-table-column>
					</el-table>
				</el-tab-pane>
				<!-- 发展对象名单管理-->
				<el-tab-pane>
					<span slot="label"><i class="el-icon-date"></i> 发展对象名单</span>
					<el-row type="flex" align="middle" class="myRow">
						<el-col :span="3">用户搜索</el-col>
						<el-col :span="7">
							<el-input placeholder="请输入姓名" v-model="queryInfo.fzdxName" clearable>
								<el-button slot="append" icon="el-icon-search" @click="mylistRoles()"></el-button>
							</el-input>
						</el-col>
						<el-col :span="2" :offset="1">发展阶段</el-col>
						<el-col :span="7">
							<el-select v-model="queryInfo.fzjd" placeholder="请选择" filterable @change="mylistRoles()">
								<el-option v-for="item in fzjdType" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-col>
					</el-row>
					<el-table :data="fzdxlist" border style="width: 100%" height="calc(100vh - 13rem)" :header-cell-style="{
						background: '#fff1f0', height: '60px', color: '#000000'
					}">
						<el-table-column type="index" width="150">
						</el-table-column>
						
						<el-table-column prop="username" label="工号" width="250px">
						</el-table-column>
						<el-table-column prop="fullName" label="姓名" width="250px">
						</el-table-column>
						<el-table-column prop="banji" label="所在班级" width="250px">
						</el-table-column>
						<el-table-column prop="fazhanjieduan" label="发展阶段" width="250px">
						</el-table-column>
					</el-table>
				</el-tab-pane>



			</el-tabs>
		</div>
	</div>
</template>

<script>
import { addActivity, getUserList, addLXLS, deleteLXLS, listLXLS, listRoles,updateUser} from "@/utils/api.js"
import * as XLSX from 'xlsx'
export default {
	data() {
		return {
			addForm: {
				date2: ''
			},
			seen: false,
			activeName2: 'dyjslist',
			succ_num: 0,
			fali_num: 0,
			queryInfo:
			{
				"userId": 0,
				"pageNumber": 1,
				"pageSize": 50,
				"fullName": "",
				"username": "",
				"role": "",
				"fzjd": '',
				"zzwyName": '',
				"fzdxName": '',

			},
			fzjdType: [
				{
					value: "",
					label: "请选择",
				}, {
					value: "团员",
					label: "团员",
				},
				{
					value: "入党积极分子",
					label: "入党积极分子",
				}, {
					value: "预备党员",
					label: "预备党员"
				}],
			//表格数据
			dylslist: [],
			zzwylist: [],
			fzdxlist: [],
			//控制上传申请书对话框的显示与隐藏
			addUserDialogVisible: false,
			//控制批量导入结果对话框
			importdialogVisible: false,
			addUserForm: {
				username: '',
				fullName: '',
				mobile: '',
				banji: ''
			},
			"userId": {},
			addUserFormRules: {
				username: [{
					required: true, message: "请正确填写工号"
				}],
				banji: [{
					required: true, message: "请填写班级"
				}],
			}

		}
	},
	created() {
		this.mygetlistLXLS();
		this.mylistRoles();

	},
	methods: {
		/**
		 * 下载模板
		 */
		downloadMoban() {
			console.log("开始下载")
			var sheet = XLSX.utils.json_to_sheet([{ 工号: "2020001206", 姓名: "团战崩了", 联系班级: "信息安全技术应用23-10" }])
			this.openDownloadDialog(this.sheet2blob(sheet), '党员联系老师导入模板.xlsx');
		},
		/**
		 * sheet转blob
		 */
		sheet2blob(sheet, sheetName) {
			sheetName = sheetName || 'sheet1';
			var workbook = {
				SheetNames: [sheetName],
				Sheets: {}
			};
			workbook.Sheets[sheetName] = sheet; // 生成excel的配置项

			var wopts = {
				bookType: 'xlsx', // 要生成的文件类型
				bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
				type: 'binary'
			};
			var wbout = XLSX.write(workbook, wopts);
			var blob = new Blob([s2ab(wbout)], {
				type: "application/octet-stream"
			}); // 字符串转ArrayBuffer
			function s2ab(s) {
				var buf = new ArrayBuffer(s.length);
				var view = new Uint8Array(buf);
				for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
				return buf;
			}
			return blob;
		},
		/**
		 * 下载sheet
		 * @param {*} url 
		 * @param {*} saveName 
		 */
		openDownloadDialog(url, saveName) {
			if (typeof url == 'object' && url instanceof Blob) {
				url = URL.createObjectURL(url); // 创建blob地址
			}
			var aLink = document.createElement('a');
			aLink.href = url;
			aLink.download = saveName || ''; // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
			var event;
			if (window.MouseEvent) event = new MouseEvent('click');
			else {
				event = document.createEvent('MouseEvents');
				event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
			}
			aLink.dispatchEvent(event);
		},
		myaddActivity() {
			addActivity(this.addActiForm).then(result => {
				if (result.code === '0000') {
					this.$message.success(result.message);
					this.addActivityDialogVisible = false;
					this.mygetActivityList();
				} else {
					console.log(result)
				}
			})

		},
		mydelete(banji, id) {
			const param = { "userId": id, "banji": banji }
		},
		mygetlistLXLS() {
			listLXLS(this.queryInfo).then(result => {
				if (result.code === '0000') {
					for (let i in result.data) {
						result.data[i].seen = false;
					}
					this.dylslist = result.data;
				} else {
					console.log(result)
				}
			})
		},
		queryLXLS() {
			getUserList(this.addUserForm).then(result => {
				if (result.code === '0000') {
					if (result.data[1][0] == 0) {
						this.$message('用户不存在，请输入正确的工号/学号');
					} else {
						this.addUserForm.fullName = result.data[0][0].fullName;
						this.addUserForm.mobile = result.data[0][0].mobile;
					}
				} else {
					console.log(result)
				}
			})

		},
		myaddLXLS() {
			addLXLS(this.addUserForm).then(result => {
				if (result.code === '0000') {
					this.mygetlistLXLS();
					this.$message.success(result.message);
					this.addUserDialogVisible = false;
					this.$refs.addUserFormRef.resetFields()

				} else {
					console.log(result)
				}
			})

		},
		mylistRoles() {
			const param1 = { "role": '组织委员', "fullName": this.queryInfo.zzwyName };
			const param2 = { "role": '入党积极分子', "fullName": this.queryInfo.fzdxName, 'fazhanjieduan': this.queryInfo.fzjd };
			listRoles(param1).then(result => {
				if (result.code === '0000') {
					console.log(result.data);
					this.zzwylist = result.data[0];

				} else {
					console.log(result)
				}
			})
			listRoles(param2).then(result => {
				if (result.code === '0000') {
					this.fzdxlist = result.data[0];

				} else {
					console.log(result)
				}
			})

		},
		mydeleteLXLS(banji, id) {
			const param = { "userId": id, "banji": banji }
			deleteLXLS(param).then(result => {
				if (result.code === '0000') {
					this.$message.success(result.message);
					this.mygetlistLXLS();
				} else {
					console.log(result)
				}
			})
		},
		//批量导入文件时调用接口
		myimportApi(source) {
			let num_succ = 0;
			let num_fail = 0;

			for (let i in source) {
				addLXLS(source[i]).then(result => {
					if (result.code === '0000') {
						this.mygetlistLXLS();
						this.importdialogVisible = true;
						num_succ++;
			
						if (i == source.length - 1) {
							
							this.succ_num = num_succ;
							this.fali_num=num_fail;
						}

					} else {
						this.mygetlistLXLS();
						this.importdialogVisible = true;
						num_fail++;
						if (i == source.length - 1) {
							this.succ_num = num_succ;
							this.fali_num=num_fail;
						}
					}
				})
			}
		},
		// 批量导入
		importData(file, fileList) {
			if (file.status !== 'ready') return;
	
			// 拿取文件对象
			const f = file.raw
			// 用 FileReader 来读取
			let reader = new FileReader()
			// 重写 FileReader 上的 readAsBinaryString 方法
			FileReader.prototype.readAsBinaryString = f => {
				let binary = ''
				let wb // 读取完成的数据
				let outdata // 你需要的数据
				let reader = new FileReader()
				reader.onload = e => {
					// 读取成Uint8Array，再转换为Unicode编码（Unicode占两个字节）
					let bytes = new Uint8Array(reader.result)
					let length = bytes.byteLength
					for (let i = 0; i < length; i++) {
						binary += String.fromCharCode(bytes[i])
					}
					// 接下来就是xlsx了，具体可看api
					wb = XLSX.read(binary, {
						type: 'binary',
						cellDates: false
					})
					outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]])
					const source = this.generateParam(outdata)

					// 下面就进行接口调用了...


					this.myimportApi(source);

				}
				reader.readAsArrayBuffer(f)
			}
			reader.readAsBinaryString(f)
		},
		// 生成导入参数
		generateParam(data) {
			const params = []
			// 这里根据实际表格 title 值、接口参数值，灵活变化
			const parse = {
				工号: 'username',
				姓名: 'fullName',
				联系班级: 'banji',
			}
			data.forEach(item => {
				let obj = {}
				const keys = Object.keys(parse)
				const itemKeys = Object.keys(item)
				itemKeys.forEach(key => {
					const val = item[key]
					if (keys.includes(key)) {
						obj[parse[key]] = val
					}
				})
				params.push(obj)
			})
			return params
		}

	}
}
</script>

<style>
.title {
	font-size: 20px;
}

.basicInfo {
	height: 300px;
	width: 500px;
	background-color: bisque;
}

.el-dialog__header {
	background: #efb8b8 !important;
}

.el-dialog .el-button--primary {
	background: #efb8b8 !important;
}

.tabname {
	margin-top: 50px;
}

.tabname .el-tabs__item.is-active {
	color: #e43f3e;
	font-size: 20px;
}

.tabname .el-tabs__active-bar {
	background-color: #e43f3e;
}

.tabname .el-tabs__item:hover {
	font-size: 20px;
	color: #000;

}

.el-upload {
	width: 100%;
}

.el-upload .el-upload-dragger {
	width: 100%;
}

.el-breadcrumb .el-breadcrumb__inner {
	color: grey;
	font-size: 18px;
}

.myRow {
	margin-top: 50px;
	margin-bottom: 30px;
	margin-left: 20px;
	font-size: 18px;
	font-weight: 500;
	color: #696767;
}

.myRow .el-button--primary:focus,
.myRow .el-button--primary:hover {
	background-color: #fff;
	color: #e43f3e;
	border-radius: 18px !important;
	width: 130px;
	font-size: 18px;
	border-color: #e43f3e;
}

.myRow .el-button--primary {
	background: #e43f3e;
	border-color: #e43f3e;
	color: #fff;
	border-radius: 18px !important;
	font-size: 18px;
}
</style>